import React from 'react'
import { Card, CardHeader, CardText, CardActions } from 'material-ui/Card'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import RaisedButton from 'material-ui/RaisedButton'

import DateTimePicker from '../../../date-time-picker'

const isComplete = offer =>
  offer.offer_session_sale_id && offer.offer_session_sale_expires_at

const OfferSessionSale = props => (
  <Card>
    <CardHeader title='Send Session Offer' />
    <CardText>
      <p>
        Send the user an email with an offer to create a reservation
        in the current session or a future session.
      </p>
      <SelectField
        hintText='Session Sale'
        value={props.offer.offer_session_sale_id}
        onChange={(e, index, value) => {
          props.onChange({ ...props.offer, offer_session_sale_id: value })
        }}
        maxHeight={200}
        fullWidth
      >
        {props.sessionSales.map(sessionSale => {
          return (
            <MenuItem
              key={sessionSale.id}
              value={sessionSale.id}
              primaryText={sessionSale.title}
            />
          )
        })}
      </SelectField>
      <DateTimePicker
        value={props.offer.offer_session_sale_expires_at || null}
        name='Offer Expiry'
        onChange={(e, value) => {
          props.onChange({ ...props.offer, offer_session_sale_expires_at: value })
        }}
      />
    </CardText>
    <CardActions>
      <RaisedButton
        label='Send Offer'
        primary
        onClick={props.onSubmit}
        disabled={!isComplete(props.offer)}
      />
    </CardActions>
  </Card>
)

// @ts-ignore
OfferSessionSale.propTypes = {
  offer: React.PropTypes.object.isRequired,
  onChange: React.PropTypes.func.isRequired,
  onSubmit: React.PropTypes.func.isRequired,
  sessionSales: React.PropTypes.arrayOf(React.PropTypes.shape({
    id: React.PropTypes.number.isRequired,
    title: React.PropTypes.string.isRequired
  })).isRequired
}

export default OfferSessionSale
